/**
 * 归一化点云强度
 * @param points - 点云数据，格式为 [x, y, z, intensity]。
 * @returns 归一化后的点云数据，每个点包含归一化的 intensity。
 */
import type { PointCloud, NormalizedPointCloud } from './types'

export function normalizeIntensity(points: PointCloud[]): NormalizedPointCloud[] {
  if (points.length === 0) {
    return []
  }

  // 获取所有 points 中的最大和最小 intensity 值
  const intensities = points.map((p) => p[3])
  const minIntensity = Math.min(...intensities)
  const maxIntensity = Math.max(...intensities)

  // 防止除以 0
  const range = maxIntensity - minIntensity || 1

  // 归一化
  return points.map((p) => {
    const normalizedIntensity = (p[3] - minIntensity) / range
    return {
      ...p,
      normalizedIntensity,
    } as NormalizedPointCloud
  })
}
